<template>
  <div>
    <!-- Webcam access -->
    <h3 :class="{ passed: audioAccessFulfilled }">4. Microphone Access</h3>

    <p>We need access to record audio during the exam.</p>

    <p v-if="audio_status === 'not_allowed'">
      <strong>Access to audio is blocked!</strong>
      <br />
      Please make sure your your microphone is turned on, you must do this manually. then refresh the page.
    </p>
    <p v-if="audio_status === 'not_available'">
      <strong>Audio is not available!</strong>
      <br />
      Please make sure your system have microphone and it is turned on, then refresh the page.
    </p>
    <p v-if="audio_status === 'unknown_error'">
      <strong>Unknown error!</strong>
      There was an unknown error while trying to access your microphone Please turn on MIC and refresh the
      page. If problem not solved, you have to change your browser or OS.
    </p>
    <button v-if="!audioAccessFulfilled" @click="checkAudio">Check microphone</button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { getAudioStream } from '../../plugins/webcam'

export default {
  computed: {
    ...mapState('invigilate', ['audio_status']),
    ...mapGetters('invigilate', ['audioAccessFulfilled']),
  },

  methods: {
    async checkAudio() {
      let { stream, status } = await getAudioStream()
      this.$store.dispatch('invigilate/setAudio', { stream, status })
    },
  },
}
</script>
